//import { GameResult, PairResult } from '../round-result.ts';
//import { wrapColumn, wrapRow } from './shared.ts';
//import { SharedBigRoad } from './shared-big-road.ts';
//import { DownRoad, DownRoadGap, generateDownRoadData, } from './down-road.ts';


import { wrapColumn, wrapRow } from './shared.js';
import { SharedBigRoad } from './shared-big-road.js';
import { DownRoad, generateDownRoadData, } from './down-road.js';

function generateBigEyeRoadItemList(bigRoadItemGraph) {
    return generateDownRoadData(bigRoadItemGraph, 1);//DownRoadGap.BigEyeRoadGap);
}
function generateBigEyeRoadGraph(bigEyeRoadData, rowCount, columnCount) {
    return wrapRow(wrapColumn(bigEyeRoadData, (previousItem, currentItem) => previousItem.repetition === currentItem.repetition), rowCount, columnCount);
}
class BigEyeRoad extends DownRoad {
    constructor(row, column, roundResults) {
        super(row, column, roundResults);
        this.row = row;
        this.column = column;
        this.roundResults = roundResults;
        const bigRoad = new SharedBigRoad(row, roundResults.length, roundResults);
        const bigEyeRoadData = generateBigEyeRoadItemList(bigRoad.rawArray);
        this.array = generateBigEyeRoadGraph(bigEyeRoadData, row, column);
    }
    get bankerPrediction() {
        const fakeNextRound = {
            order: this.roundResults.length,
            result: 0, // Dummy
            gameResult: 1,//GameResult.BankerWin,
            pairResult: 0,//PairResult.NoPair,
        };
        return this.getPrediction(fakeNextRound, 1);//DownRoadGap.BigEyeRoadGap);
    }
    get playerPrediction() {
        const fakeNextRound = {
            order: this.roundResults.length,
            result: 0, // Dummy
            gameResult: 2,//GameResult.PlayerWin,
            pairResult: 0,//PairResult.NoPair,
        };
        return this.getPrediction(fakeNextRound, 1);//DownRoadGap.BigEyeRoadGap);
    }
}

export {BigEyeRoad, generateBigEyeRoadItemList, generateBigEyeRoadGraph};
